<template>
    <div>
        <main-map :currentsearch="geojson" :host="host" :colors="colors"></main-map>


            <div class="search-banner  d-none d-lg-block d-xl-block">
                <div class="container-src">
                    <CampiFormRicerca
                        :colors="colors"
                        :currentsearch="currentsearch"
                        :homepagedata="homepagedata"
                        :formdata="formdata"
                        :selectedValue="selectedValue"
                        :cattegorie="homepagedata.categorie"
                        :show_categorie_select="true"
                        @get-tipologie="getTipologie"
                        @update-prezzi="getPrezzi"
                        @showmap="showMap"
                        @removeselection="removeSelection"
                        :mobile="false"
                    />
                </div>
            </div>
            <div class="d-lg-none d-xl-none">
                <Mobile-form
                    :currentsearch="currentsearch"
                    :colors="colors"
                    :homepagedata="homepagedata"
                    :formdata="formdata"
                    :selectedValue="selectedValue"
                    :mobile="true"
                    @get-tipologie="getTipologie"
                    @removeselection="removeSelection"
                    @showmap="showMap"
                    @update-prezzi="getPrezzi"
                >
                </Mobile-form>
            </div>

    </div>
</template>

<script>
import CampiFormRicerca from "./CampiFormRicerca";
import MobileFormComponent from './MobileFormRicerca.vue';
export default {
    components: {
        'CampiFormRicerca': CampiFormRicerca,
        'Mobile-form': MobileFormComponent
    },
    props: ['homepagedata', 'geojson', 'currentsearch', 'colors', 'categoria_selected','mobile', 'host'],
    data() {
        return {
            contratti: null,
            formdata: {
                contratti: [],
                filtriAvanzati: [],
                tipologie: [],
                zone: [],
                categorie: [],
                prezzi: [],
            },
            selectedValue: {
                contratto: null,
                tipologie: [],
                zone: [],
                categoria: null,
                geojson: null
            }
        }
    },
    methods: {
        showMap() {
            this.$root.showMap();
            this.$set(this.selectedValue, 'zone', []);
        },
        getPrezzi(selected) {
            if ( selected ) {
                window.axios
                    .get(window.base_url + 'dropdowns/price-ranges/' + selected.id)
                    .then( res => {
                        this.$set(this.formdata, 'prezzi', res.data.prezzi);
                    });
            }
        },
        getTipologie(selected) {

            let sel;

            this.prezzi = [];
            this.filtriAvanzati = [];

            if(selected) {
                sel = selected.id;

                if(sel != this.currentsearch.categoriaSelected.id){
                    this.$set(this.formdata, 'tipologie', []);
                    this.$set(this.formdata, 'contratti', []);
                    this.$set(this.formdata, 'filtriAvanzati', []);
                    this.$set(this.formdata, 'prezzi', []);

                    this.$set(this.selectedValue, 'contratto', null);
                    this.$set(this.selectedValue, 'tipologie', []);
                }

                window.axios.get(window.base_url + 'forms/ricerca/' + sel).then( res => {
                    this.$set(this.formdata, 'tipologie', res.data.data.tipologie);
                    this.$set(this.formdata, 'contratti', res.data.data.contratti);
                    this.$set(this.formdata, 'filtriAvanzati', res.data.data.filtri_avanzati);
                });
            }
        },
        removeSelection() {
            this.$root.mapselected = false;
            this.$set(this.selectedValue, 'geojson', null);
            document.getElementById('geojson_desktop').value = '';
            document.getElementById('geojsonmobile').value = '';
        }
    },
    mounted() {
        if(this.currentsearch && this.currentsearch.geojson) {
            this.$root.mapselected = true;
            this.$set(this.selectedValue, 'geojson', this.currentsearch.geojson);
            $('#geojson_desktop').val(JSON.stringify(this.currentsearch.geojson));
            $('#geojsonmobile').val(JSON.stringify(this.currentsearch.geojson));
        }
        this.$set(this.formdata, 'categorie', this.homepagedata.categorie);
        this.$set(this.formdata, 'zone', this.homepagedata.zone);

        if(this.currentsearch) {
            this.$set(this.selectedValue, 'contratto', this.currentsearch.contrattoSelected ? this.currentsearch.contrattoSelected : null);
            this.$set(this.selectedValue, 'tipologie', this.currentsearch.tipologieSelected ? this.currentsearch.tipologieSelected : []);
            this.$set(this.selectedValue, 'categoria', this.currentsearch.categoriaSelected ? this.currentsearch.categoriaSelected : null);
            this.currentsearch.zoneSelected ? this.$set(this.selectedValue, 'zone', this.currentsearch.zoneSelected) : '';
        };
    },
}
</script>

